var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 135",
    width: 136,
    height: 135,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1ece68}.b{fill:#fefefe}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m135.7 67.5c0 37.2-30.3 67.5-67.5 67.5-37.3 0-67.5-30.3-67.5-67.5 0-37.3 30.2-67.5 67.5-67.5 37.2 0 67.5 30.2 67.5 67.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m73.4 58.3c1.1-1.3 2-2.6 3.1-3.6 3.5-3.3 7.7-5 12.5-5 2.7 0.1 5.3 0.3 7.9 1 5.8 1.7 9.2 5.7 10.9 11.5 1.2 4.2 1.4 8.7 1.4 13.1 0 9.3 0 18.6 0 27.9 0 0.9-0.2 1.1-1.1 1.1q-7.2 0-14.4 0c-0.9 0.1-1-0.2-1-1q0-13.3 0-26.6c0-2.3-0.2-4.5-0.8-6.6-1.2-4-4-6-8.2-5.8-5.7 0.3-8.6 3.1-9.4 8.9q-0.2 2.1-0.2 4.1c0 8.7 0 17.3 0 25.9 0 0.9-0.2 1.2-1.1 1.1q-7.2 0-14.5 0c-0.8 0-1-0.2-1-0.9q0-25.7 0-51.3c0-0.8 0.3-1 1.1-1q6.9 0 13.8 0c0.8 0 1 0.2 1 1 0 2.1 0 4.1 0 6.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m47.1 77.8q0 12.7 0 25.3c0 1-0.2 1.3-1.2 1.2q-7.2 0-14.4 0c-0.8 0-1-0.1-1-0.9q0-25.7 0-51.4c0-0.7 0.2-0.9 0.9-0.9q7.3 0 14.6 0c1 0 1.1 0.3 1.1 1.1q0 12.8 0 25.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m48.4 34.1c0 5.3-4.3 9.6-9.6 9.6-5.2 0-9.6-4.3-9.6-9.5 0-5.3 4.3-9.6 9.6-9.6 5.3 0 9.6 4.3 9.6 9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.565252891fa71a7b63bb22e6f0601102.svg";
export { ForwardRef as ReactComponent };